export function stringToTitleCase(string) {
    const newString = string.split('');
    const firstLetter = newString.shift();
    const titleCase = firstLetter.toUpperCase() + newString.join('');
    return titleCase;
}

export const fileUpload = file => {
    const formData = new FormData();
    formData.append('file', file);
    return formData;
};

export const extractFilename = path => {
    if (path.substr(0, 12) === 'C:\\fakepath\\') return path.substr(12); // modern browser
    var x;
    x = path.lastIndexOf('/');
    if (x >= 0)
        // Unix-based path
        return path.substr(x + 1);
    x = path.lastIndexOf('\\');
    if (x >= 0)
        // Windows-based path
        return path.substr(x + 1);
    return path; // just the filename
};

export const setStoreLocal = (name, item) => {
    return localStorage.setItem(name, item);
};

export const getStoreLocal = name => {
    return localStorage.getItem(name);
};

export const removeStoreLocal = name => {
    return localStorage.removeItem(name);
};

export const formatDate = value => {
    return new Date(value).toDateString();
};

/**
 * @param obj1 First Object
 * @param obj2 Second Object
 * @param values1 Array of strings
 * @param value2 Array of Strings
 * @returns Boolean value
 * */

export const detectChanges = (obj1, obj2, values1, values2) => {
    //   helper function to convert object to array
    const getObjectLength = obj => Object.keys(obj).length;
    const getValues = obj => Object.values(obj);

    let maxLength = getObjectLength(obj1) > getObjectLength(obj2) ? getObjectLength(obj1) : getObjectLength(obj2);
    const length = values1 === undefined || values2 === undefined ? maxLength : values1.length;

    for (var i = 0; i < length; i++) {
        const currentValue1 = values1 !== undefined ? obj1[values1[i]] : getValues(obj1)[i];
        const currentValue2 = values2 !== undefined ? obj2[values2[i]] : getValues(obj2)[i];
        if (currentValue1 !== currentValue2) return true;
    }
    return false;
};

/**
 * @param id Either id or a unique identifier to be used as key
 * @param obj new object to replace the objected to be removed
 * @param arr An array containing all values
 * @param sortBy (Optional) After replacing sort new collection by
 * @returns Array of new sorted values
 * */

export const updateRecord = (id, obj, arr, sortBy) => {
    const filteredArr = arr.filter(v => id !== v.id);
    const newArr = [obj, ...filteredArr];
    const compare = (a, b) => (a[sortBy] < b[sortBy] ? -1 : 1);

    const result = sortBy === undefined ? newArr : newArr.sort(compare);
    return result;
};

export const updateRecordDelete = (id, arr) => {
    return arr.filter(v => id !== v.id);
};
export const replaceAllComma = value => {
    if (typeof value === 'number') return value;
    return value.replace(/[, ]+/g, '').trim();
};

/**
 *
 * @param {*} array Array of objects (not nested)
 * @param {*} value The key to use in searching
 * @returns {Object}
 */
export const getARecord = (array, field, key) => array.find(value => value[field] === key);

export const getTodaysDate = () => new Date();
/**
 *
 * @param {int} value Number to subtract from date function
 * @returns {Date}
 */
export const getSpecificDate = value => {
    const date = new Date();
    date.setDate(date.getDate() - value);
    return date;
};

export const checkBothFieldsUndefined = (field1, field2) => {
    return field1 === undefined && field2 === undefined;
};

export const checkEitherUndefined = (field1, field2) => {
    return field1 === undefined || field2 === undefined;
};

export const hyphenDateFormat = dateString => {
    return new Date(dateString).toISOString().substring(0, 10);
};
